__turbopack_context__.v({
  "logo": "mKMYAG_logo",
});
